import { uniqBy } from 'lodash-es';
import b2bCartHelpers from 'Assets/js/components/b2bCartHelpers';

const actions = {
  async removeB2bGlobalProduct(context, payload) {
    const productId =
      typeof payload === 'object' && payload !== null
        ? payload.productId
        : payload;

    if (!productId) {
      return;
    }

    context.commit('removingRecipientProductById', productId);
    context.commit('removeB2bGlobalProduct', productId);
    context.dispatch('checkIfWeNeedToDeleteAnOrder');
  },
  async getB2BUserOrderNextBatch(context, payload) {
    const currentOrders = context.state.b2b.orders || [];

    const response = await context.getters.userInstance.getB2BUserOrderNextBatch(
      context.state.user?.id,
      payload.cursor
    );

    if (response.orders?.length) {
      context.commit(
        'setB2bOrders',
        uniqBy(currentOrders.concat(response.orders), (order) => order.id)
      );

      context.commit('setB2bTotalOrders', response.totalOrders);
      context.commit('setB2bOrderPagination', response.orderPagination);
    }
    return response;
  },
  async setB2bCartTotalCartPriceForUser(context, payload) {
    context.dispatch('addDispatchProductForTotal', payload).then(() => {
      const usersCartTotal = context.getters.getB2bUserCartTotal({
        market: payload.market,
        id: payload.userId
      });
      const usersCartWeight = context.getters.getB2bUserCartWeight({
        market: payload.market,
        id: payload.userId
      });

      const shippingPayload = {
        market: payload.market,
        productId: payload.productId,
        weight: usersCartWeight,
        carttotal: usersCartTotal,
        recipientId: payload.userId
      };

      context
        .dispatch('getShippingCost', shippingPayload)
        .then((shippingCost) => {
          context.commit('setB2bUserCartShippingCost', {
            market: payload.market,
            id: payload.userId,
            shipping: shippingCost
          });
          return shippingCost;
        });
    });
  },
  async checkIfWeNeedToDeleteAnOrder(context) {
    const b2bCarts = Object.entries(context.getters.b2bCarts);
    // eslint-disable-next-line no-restricted-syntax
    for (const cart of b2bCarts) {
      const market = cart[0];
      const theCart = cart[1];
      if (Object.values(theCart.contactItems).length === 0) {
        if (theCart.order.id && theCart.order.status === 'pending') {
          const b2bHelper = b2bCartHelpers.getInstance();
          // @todo Missing await or add .then()
          b2bHelper.deleteOrderById(theCart.order.id, () => {
            context.commit('resetMarketCartOrder', market);
          });
        }
      }
    }
  },
  async dumpEmptyProductsFromCart(context) {
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(
      context.getters.b2bGlobalProducts
    )) {
      if (Object.values(value.recipients).length === 0) {
        context.commit('removeB2bGlobalProduct', key);
      }
    }
  },
  async purgeMarketFromCart(context, payload) {
    const productAndRecipients = context.getters.getProductAndRecipintsByMarket(
      payload
    );

    const entries = Object.entries(productAndRecipients);

    entries.forEach(([key, value]) => {
      context.commit('removeUserProductFromGlobalCart', {
        productId: value,
        lineItemId: key
      });
      context.dispatch('dumpEmptyProductsFromCart');
    });
  },
  async checkOrderStatus(context, payload) {
    const currentOrders = context.state.b2b.orders || [];

    const b2bHelper = b2bCartHelpers.getInstance();
    await b2bHelper.getOrderStatus(payload.id, (response) => {
      if (response && response.status !== 'PENDING') {
        context.commit('setOrderStatus', {
          market: payload.market,
          status: response.status
        });
        context.dispatch('purgeMarketFromCart', payload.market);
        context.commit('purgeMarket', payload.market);
        context.getters.userInstance.getUser(
          context.getters.cartInstance,
          (nxtResponse) => {
            context.commit(
              'setB2bOrders',
              uniqBy(
                currentOrders.concat(nxtResponse.b2b.orders),
                (order) => order.id
              )
            );

            context.commit('setB2bTotalOrders', nxtResponse.b2b.totalOrders);
            context.commit(
              'setB2bOrderPagination',
              nxtResponse.b2b.orderPagination
            );

            window.dispatchEvent(
              new CustomEvent('cart-changed', {
                detail: {
                  cart: context.getters.cartInstance.getCart()
                }
              })
            );
          }
        );
      }
    });
  }
};

export default actions;
